import React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

const View = ({ setViewShowModal, details }) => {
  const { t } = useTranslation()
  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px] h-[90vh] overflow-y-auto'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
              <div className=' grid grid-cols-2 gap-5 border-2 rounded-md p-5'>
                <div className='mb-3'>
                  <div className=''><strong>{t('O_USER_ID')}:</strong></div>
                  <div>{details?.userDetails?.userUniqueId}</div>
                </div>
                <div className='mb-3'>
                  <div className=''><strong>{t('USERS_FULL_NAME')}:</strong></div>
                  <div>{Capitalize(details?.firstName) + ' ' + details?.lastName}</div>
                </div>
                <div className='mb-3'>
                  <div className=''><strong>{t('O_OCCUPATION')}:</strong></div>
                  <div>{details?.userDetails?.occupation?.map((item) => item?.label).join(', ')}</div>
                </div>
                {details?.mobile && <div className='mb-3'>
                  <div className=''><strong>{t('O_MOBILE_NUMBER')}:</strong></div>
                  <div>{details?.countryCode + ' ' + details?.mobile}</div>
                </div>}
                {details?.telephone && <div className='mb-3'>
                  <div className=''><strong>{t('O_TELEPHONE')}:</strong></div>
                  <div>{details?.telephone}</div>
                </div>}
                {details?.fax && <div className='mb-3'>
                  <div className=''><strong>{t('O_FAX')}:</strong></div>
                  <div>{details?.fax}</div>
                </div>}
                {details?.addressLine1 && <div className='mb-3'>
                  <div className=''><strong>{t('O_STREET_ADDRESS_LINE_1')}:</strong></div>
                  <div>{details?.addressLine1}</div>
                </div>}
                {details?.addressLine2 && <div className='mb-3'>
                  <div className=''><strong>{t('O_STREET_ADDRESS_LINE_2')}:</strong></div>
                  <div>{details?.addressLine2}</div>
                </div>}
                {details?.city && <div className='mb-3'>
                  <div className=''><strong>{t('O_CITY')}:</strong></div>
                  <div>{Capitalize(details?.city)}</div>
                </div>}
                {details?.state && <div className='mb-3'>
                  <div className=''><strong>{t('O_STATE')}:</strong></div>
                  <div>{Capitalize(details?.state)}</div>
                </div>}
                {details?.postalCode && <div className='mb-3'>
                  <div className=''><strong>{t('O_POSTAL_CODE')}:</strong></div>
                  <div>{details?.postalCode}</div>
                </div>}
                {details?.status && <div className='mb-3'>
                  <div className=''><strong>{t('O_STATUS')}:</strong></div>
                  <div>{Capitalize(details?.status)}</div>
                </div>}
                <div className='mb-3'>
                  <div className=''><strong>{t('O_CREATED_AT')}:</strong></div>
                  <div>{dayjs(details?.createdAt).format('DD-MM-YYYY hh:mm A')}</div>
                </div>
                {details?.responseDate && <div className='mb-3'>
                  <div className=''><strong>{t('O_RESPONSE_DATE')}:</strong></div>
                  <div>{dayjs(details?.responseDate).format('DD-MM-YYYY hh:mm A')}</div>
                </div>}
                <div className='mb-3 col-span-2'>
                  <div className=''><strong>{t('O_DESCRIPTION')}:</strong></div>
                  <div className='break-all' dangerouslySetInnerHTML={{__html: details?.description}}></div>
                </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setViewShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default View
